<template>
  <section class="homepage-services-wheel">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="homepage-services-wheel__introduction typography">
            <ContentArea
              v-bind:content="services"
              prefix=""
              title_field_tag="h2"
            ></ContentArea>
          </div>
          <!--                    {{services}}-->
          <ul class="homepage-services-wheel__navigation">
            <li
              v-for="(item, index) in services.services"
              v-bind:key="`service_` + index"
            >
              <a
                href="#"
                v-on:click.prevent="display_service(index)"
                v-bind:class="active_service_index === index ? 'active' : 'x'"
              >
                {{ item.content_title }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6 offset-md-2">
          <div
            v-if="services.wheel_image"
            class="homepage-services-wheel__service-wheel"
            v-bind:style="{
              backgroundImage: 'url(\'' + services.wheel_image + '\')',
              transform: 'rotate(' + wheel_rotation + 'deg)'
            }"
          ></div>
          <div class="homepage-services-wheel__service-content typography">
            <div class="homepage-services-wheel__service-content__nav">
              <a
                href="#"
                class="btn btn-nav btn-nav--prev"
                v-on:click.prevent="go_to_prev_service"
              ></a>
              <a
                href="#"
                class="btn btn-nav btn-nav--next"
                v-on:click.prevent="go_to_next_service"
              ></a>
            </div>
            <div
              ref="service_content_inner"
              class="homepage-services-wheel__service-content__inner"
            >
              <ContentArea
                v-bind:content="active_service"
                prefix=""
                title_field_tag="h4"
              ></ContentArea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContentArea from "../components/ContentArea";
import store from "../store/index";

export default {
  name: "HomepageServices",
  components: { ContentArea },
  store: store,
  data: function() {
    return {
      services: window.homepage_services,
      active_solution_index: 0,
      current_wheel_rotation: 0
    };
  },
  mounted() {
    // alert(store.getters.template_dir_uri)
  },
  methods: {
    display_service(service_index) {
      this.$refs["service_content_inner"].classList.add(
        "homepage-services-wheel__service-content__inner--hidden"
      );
      this.active_service_index = service_index;

      setTimeout(() => {
        this.$refs["service_content_inner"].classList.remove(
          "homepage-services-wheel__service-content__inner--hidden"
        );
      }, 300);
    },
    go_to_prev_service() {
      let service_index = --this.active_solution_index;
      if (this.active_solution_index === 0) {
        service_index = this.services.services.length - 1;
      }
      this.display_service(service_index);
    },
    go_to_next_service() {
      let service_index = this.active_solution_index + 1;
      if (this.active_solution_index === this.services.services.length - 1) {
        service_index = 0;
      }
      this.display_service(service_index);
    }
  },
  computed: {
    active_service() {
      return this.services.services[this.active_solution_index];
    },
    wheel_rotation() {
      let number_wheel_segments = 8;
      let segment_size_degrees = 360 / number_wheel_segments;
      let rotation = segment_size_degrees * this.active_solution_index;
      return 0 - rotation;
    }
  }
};
</script>

<style scoped lang="scss">
.homepage-services-wheel {
  z-index: 5;
  position: relative;

  &__introduction {
  }

  &__navigation {
    columns: 2;
    column-gap: 32px;
    margin-top: 12px;

    li {
      color: #dc281e;
      border-bottom: 1px solid #dcdcdc;
      padding: 12px 0;
      cursor: pointer;

      &:first-child {
        border-top: 1px solid #dcdcdc;
      }
    }
  }

  &__service-wheel {
    background-color: #dc281e;
    width: 544px;
    height: 544px;
    border-radius: 100%;
    background: {
      position: center;
      repeat: no-repeat;
      size: auto;
    }
    position: relative;
    left: -192px;
    top: -48px;
    transition: transform 0.3s ease;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.16);
  }

  &__service-content {
    position: absolute;
    top: 115px;
    background: rgb(245, 245, 245);
    background: linear-gradient(
      120deg,
      rgba(245, 245, 245, 1) 0%,
      rgba(255, 255, 255, 1) 60%
    );
    padding: 53px 24px;

    &__inner {
      opacity: 1;

      &--hidden {
        transition: opacity 0.15s ease;

        opacity: 0;
      }
    }

    &:after {
      content: "";
      position: absolute;
      top: -28px;
      left: 53px;
      width: 57px;
      height: 57px;
      background: {
        image: url("../../../images/wheel-arrow.svg");
        repeat: no-repeat;
        position: top left;
        size: auto;
      }
    }

    &__nav {
      display: flex;
      position: absolute;
      top: -40px;
      right: 15px;

      a:first-child {
        margin-right: 1px;
      }
    }
  }
}
</style>
